import App from './views/App'
import * as ReactDOMClient from 'react-dom/client'

const updateSizeCssVariables = () => {
  document.documentElement.style.setProperty('--height', `${window.innerHeight}px`)
  document.documentElement.style.setProperty('--width', `${window.innerWidth}px`)
}
window.addEventListener('resize', updateSizeCssVariables)
updateSizeCssVariables()

const root = ReactDOMClient.createRoot(document.getElementById('sightcall-root') as HTMLElement)

root.render(<App />)
